import { resolveAssetUrl } from '../config';

export default function StickyAddToCart({ product, selectedVariant, quantity, onQuantityChange, onAddToCart, onBuyNow, addingToCart }) {
    const displayPrice = selectedVariant?.displayPrice ?? selectedVariant?.price?.sale_price ?? 0;
    const isOutOfStock = (() => {
        if (!selectedVariant) return true;
        if (typeof selectedVariant.purchasable === "boolean") {
            return !selectedVariant.purchasable;
        }
        if (selectedVariant.forceOutOfStock) return true;
        return (selectedVariant.stockCount ?? 0) === 0;
    })();

    // Get the primary image from variant
    const primaryImg = selectedVariant?.variantImage?.find(img => img.isPrimary)
        || selectedVariant?.variantImage?.[0];
    const imageUrl = primaryImg ? resolveAssetUrl(primaryImg.path) : null;

    return (
        <div className="fixed bottom-0 left-0 right-0 bg-card border-t-2 border-border shadow-lg z-40 lg:hidden">
            <div className="max-w-[1400px] mx-auto px-4 py-2.5">
                <div className="flex items-center gap-3">
                    {/* Product Info */}
                    <div className="flex items-center gap-3 flex-1 min-w-0">
                        <div className="w-11 h-11 bg-muted rounded-lg overflow-hidden flex-shrink-0">
                            {imageUrl ? (
                                <img
                                    src={imageUrl}
                                    alt={product.name}
                                    className="w-full h-full object-contain"
                                />
                            ) : (
                                <div className="w-full h-full flex items-center justify-center">
                                    <i className="ri-image-line text-muted-foreground/40"></i>
                                </div>
                            )}
                        </div>
                        <div className="flex-1 min-w-0">
                            <p className="text-sm font-semibold text-foreground truncate">{product.name}</p>
                            <p className="text-base font-bold text-primary">
                                KSh {displayPrice.toLocaleString()}
                            </p>
                        </div>
                    </div>

                    {/* Quantity Selector */}
                    <div className="flex items-center gap-2 flex-shrink-0">
                        <button
                            onClick={() => onQuantityChange(Math.max(1, quantity - 1))}
                            className="w-8 h-8 rounded-lg border border-border flex items-center justify-center hover:bg-muted transition-colors"
                            disabled={isOutOfStock}
                        >
                            <i className="ri-subtract-line text-sm"></i>
                        </button>
                        <span className="w-6 text-center text-sm font-semibold">{quantity}</span>
                        <button
                            onClick={() => onQuantityChange(quantity + 1)}
                            className="w-8 h-8 rounded-lg border border-border flex items-center justify-center hover:bg-muted transition-colors"
                            disabled={isOutOfStock}
                        >
                            <i className="ri-add-line text-sm"></i>
                        </button>
                    </div>

                    {/* Actions */}
                    <div className="flex items-center gap-2 flex-shrink-0">
                        <button
                            onClick={onAddToCart}
                            disabled={isOutOfStock || addingToCart}
                            className="px-3 py-2 rounded-lg border border-primary text-primary text-sm font-semibold hover:bg-primary/5 disabled:opacity-50"
                        >
                            {addingToCart ? '...' : 'Add'}
                        </button>
                        <button
                            onClick={onBuyNow}
                            disabled={isOutOfStock || addingToCart}
                            className="px-3 py-2 rounded-lg bg-primary text-white text-sm font-semibold hover:bg-primary/90 disabled:opacity-50"
                        >
                            Buy
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
